
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Calendar, Clock, User, MapPin, MoreHorizontal } from 'lucide-react';

const PatientAppointments = () => {
  const appointments = [
    {
      id: '1',
      date: '2024-01-20',
      time: '2:00 PM',
      treatment: 'Botox Consultation',
      provider: 'Dr. Smith',
      status: 'confirmed',
      location: 'Austin Downtown'
    },
    {
      id: '2',
      date: '2024-01-15',
      time: '10:30 AM',
      treatment: 'Botox Treatment',
      provider: 'Dr. Johnson',
      status: 'completed',
      location: 'Austin Downtown'
    },
    {
      id: '3',
      date: '2024-01-05',
      time: '3:15 PM',
      treatment: 'Consultation',
      provider: 'Dr. Smith',
      status: 'completed',
      location: 'Austin Downtown'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'confirmed': return 'bg-green-100 text-green-800';
      case 'completed': return 'bg-blue-100 text-blue-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      case 'no-show': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold font-juv-heading" style={{ color: '#5C322B' }}>
          Appointment History
        </h2>
        <Button className="text-white" style={{ backgroundColor: '#A55C52' }}>
          <Calendar className="h-4 w-4 mr-2" />
          Book New Appointment
        </Button>
      </div>

      <div className="grid gap-4">
        {appointments.map((appointment) => (
          <Card key={appointment.id}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-4 mb-3">
                    <div className="flex items-center space-x-2">
                      <Calendar className="h-5 w-5" style={{ color: '#A55C52' }} />
                      <span className="font-medium">{new Date(appointment.date).toLocaleDateString()}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Clock className="h-5 w-5" style={{ color: '#A55C52' }} />
                      <span>{appointment.time}</span>
                    </div>
                    <Badge className={getStatusColor(appointment.status)}>
                      {appointment.status}
                    </Badge>
                  </div>
                  
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#5C322B' }}>
                    {appointment.treatment}
                  </h3>
                  
                  <div className="flex items-center space-x-4 text-sm text-gray-600">
                    <div className="flex items-center">
                      <User className="h-4 w-4 mr-1" />
                      {appointment.provider}
                    </div>
                    <div className="flex items-center">
                      <MapPin className="h-4 w-4 mr-1" />
                      {appointment.location}
                    </div>
                  </div>
                </div>
                
                <Button variant="outline" size="sm">
                  <MoreHorizontal className="h-4 w-4" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PatientAppointments;
